import { z } from 'zod';
import { ProjectPositionNumberSchema } from './shared';

const PositionSchema = z.object({
    id: z.string().uuid(),
    constructionProjectId: z.string().uuid(),
    positionNumber: ProjectPositionNumberSchema,
});

export const PositionsGroupedBySalesforceOpportunityLineItemIdSchema = z.object({
    salesforceOpportunityLineItemId: z.string(),
    positions: z.array(PositionSchema),
});

export const GetPositionsBySalesforceOpportunityIdSchema = z.array(
    PositionsGroupedBySalesforceOpportunityLineItemIdSchema
);
